import i18n from 'i18next';
import translation from './cs/translation.json';
import { initReactI18next } from 'react-i18next';

export const resources = {
  cs: {
    translation,
  },
} as const;

i18n.use(initReactI18next).init({
  debug: true,
  fallbackLng: 'cs',
  lng: 'cs',
  resources,
});
